import type { Accent } from '../data/volumes'

export interface AccentStyles {
  /** Solid block used for the volume code plate. */
  plate: string
  /** Tinted surface for the focus list. */
  surface: string
  /** Hairline border matching the accent. */
  border: string
  /** Text colour for the volume name. */
  text: string
  /** Small dot / marker colour. */
  marker: string
}

export const accentStyles: Record<Accent, AccentStyles> = {
  sage: {
    plate: 'bg-sage text-ivory',
    surface: 'bg-sage-light/60',
    border: 'border-sage/30',
    text: 'text-sage-deep',
    marker: 'bg-sage',
  },
  lilac: {
    plate: 'bg-lilac text-ivory',
    surface: 'bg-lilac-light/70',
    border: 'border-lilac/30',
    text: 'text-lilac',
    marker: 'bg-lilac',
  },
  terracotta: {
    plate: 'bg-terracotta text-ivory',
    surface: 'bg-terracotta-light/60',
    border: 'border-terracotta/30',
    text: 'text-terracotta',
    marker: 'bg-terracotta',
  },
  gold: {
    plate: 'bg-gold-ink text-ivory',
    surface: 'bg-gold-soft/60',
    border: 'border-gold/40',
    text: 'text-gold-ink',
    marker: 'bg-gold',
  },
}
